<script>
    import ChartjsPluginFunnel from './plugins/funnel'
    // import ChartjsPluginFunnel from 'chartjs-plugin-funnel'
    import { generateChart } from 'vue-chartjs'
    import createChart from './mixins/createChart'

    const Funnel = generateChart('funnel-chart', 'funnel')

    export default {
        extends: Funnel,

        mixins: [createChart],

        props: {
            chartData: {
                type: Object,
                required: true,
            },

            options: {
                type: Object,
                default: () => {
                    return {
                        gap: 0,

                        legend: {
                            display: false
                        },

                        legendCallback: chart => {

                            let text = []

                            text.push(`<ul class="${chart.id}-legend block w-full">`)

                            for (var i = 0; i < chart.data.labels.length; i++) {
                                if(typeof chart.data.datasets[1].data[i] !== 'undefined') {
                                    text.push('<li class="whitespace-no-wrap block w-full text-14">')
                                } else {
                                    text.push('<li class="whitespace-no-wrap inline-block text-14 mr-16">')
                                }
                                text.push(`<span class="inline-block w-14 h-14 mr-8" style="background-color:${chart.data.datasets[0].backgroundColor[i]}"1></span>`)
                                text.push(`${chart.data.labels[i]}, ${chart.data.datasets[0].data[i]}`)
                                if(typeof chart.data.datasets[1].data[i] !== 'undefined') {
                                    if (chart.data.datasets[0].data[i] >= chart.data.datasets[1].data[i]) {
                                        text.push(`<svg xmlns="http://www.w3.org/2000/svg" width="10" height="12.879" viewBox="0 0 10 12.879" class="inline-block mx-4 mb-4"><path d="M12.879,38.228,6.407,33.25v2.9H0v4.286H6.407V43.25Z" transform="translate(-33.25 12.879) rotate(-90)" fill="#53ff4d"/></svg>Target, ${chart.data.datasets[1].data[i]}`)
                                    } else {
                                        text.push(`<svg xmlns="http://www.w3.org/2000/svg" width="10" height="12.879" viewBox="0 0 10 12.879" class="inline-block mx-4 mb-4"><path d="M12.879,38.228,6.407,33.25v2.9H0v4.286H6.407V43.25Z" transform="translate(43.25) rotate(90)" fill="#ff5d67"/></svg>Target, ${chart.data.datasets[1].data[i]}`);
                                    }

                                }
                                text.push('</li>')
                            }

                            text.push('</ul>')

                            return text.join('')
                        },

                        sort: 'desc',

                        tooltips: {
                            // only show the data tooltips, not the targets
                            filter: function (tooltipItem) {
                                return tooltipItem.datasetIndex === 0;
                            }
                        }

                    }
                }
            },

            scheme: {
                type: String,
                default: 'dark'
            },
        },

        data () {
            return {
                dataStyling: {
                    backgroundColor: [
                        '#18BDCB', // blue
                        '#7DD0A9', // green
                        '#FFE97E', // yellow
                        '#FFB375', // orange
                        '#FF5D67', // red
                        '#B72424', // deep red
                        '#D42488', // purple
                        '#FFB1DD', // pink
                        '#C2A9B7', // mauve
                        '#757CE9', // voilet
                    ],
                    borderWidth: 0,
                    order: 0,
                },

                defaultOptions : {
                    tooltips: {
                        backgroundColor: '#0E0F20',
                        titleFontFamily: 'proxima-nova',
                        titleFontSize: 14,
                        titleSpacing: 4,
                        bodyFontFamily: 'proxima-nova',
                        bodyFontSize: 14,
                        bodySpacing: 4,
                        cornerRadius: 0,
                        xPadding: 8,
                        yPadding: 8,
                        displayColors: false
                    }
                },

                targetDataStyling: {
                    backgroundColor: [
                        'rgba(255, 93, 103, 0.1)', // red
                        'rgba(255, 179, 117, 0.1)', // orange
                        'rgba(125, 208, 169, 0.1)', // green
                        'rgba(24, 189, 203, 0.1)', // blue
                        //'#FFE97E', // yellow
                        //'#848484', // grey
                    ],
                    order: 2,
                },

                // targetChartType: 'funnel',

                originalDatasets: this.chartData.datasets.filter(dataset => !dataset.target),
                targetDatasets: this.chartData.datasets.filter(dataset => dataset.target),
            }
        },

        mounted () {
            this.buildFunnelChartData()
            this.createChart()
            this.createFunnelLegend()

            this.$on('chart:destroy', () => {
                this.buildFunnelChartData()
            })
        },

        methods: {
            buildFunnelChartData() {
                let datasetIndex = 0
                let labels = []
                let datasets = [
                    {target: false, data: []},
                    {target: true, data: []},
                ]

                if (Array.isArray(this.chartData.datasets)) {
                    for (const dataset of this.chartData.datasets) {
                        if (!dataset.target) {
                            labels.push(dataset.label)
                            datasets[datasetIndex].data.push(dataset.data[datasetIndex])
                        } else {
                            datasets[datasetIndex+1].data.push(dataset.data[datasetIndex])
                        }
                    }
                }

                this.chartData.datasets = datasets
                this.chartData.labels = labels
            },

            createFunnelLegend(){
                this.htmlLegend = this.generateLegend()

                $(this.$refs.canvas).after('<div class="relative w-full customLegend mt-10"></div>')

                let customLegend = $(this.$refs.canvas).parent().find('.customLegend')

                customLegend.html(this.htmlLegend)
            },
        }

    }
</script>